import { Flex, Link } from '@chakra-ui/react';
import { motion } from 'motion/react';
import { trackEvent } from 'utils';

const MotionLink = motion.create(Link);

interface StoreBadgesProps {
  showAppStore?: boolean;
  showPlayStore?: boolean;
  layout?: 'horizontal' | 'vertical';
  size?: 'sm' | 'md' | 'lg';
}

export function StoreBadges({
  showAppStore = true,
  showPlayStore = true,
  layout = 'horizontal',
  size = 'md',
}: StoreBadgesProps) {
  const handleStoreClick = (store: 'app-store' | 'play-store') => {
    trackEvent('store_badge_clicked', {
      store,
      layout,
    });
  };

  const badgeHeight = {
    sm: '40px',
    md: '48px',
    lg: '56px',
  }[size];

  return (
    <Flex
      direction={layout === 'horizontal' ? 'row' : 'column'}
      gap={3}
      align="center"
      justify="center"
    >
      {/* App Store Badge */}
      {showAppStore && (
        <MotionLink
          href="https://apps.apple.com/app/id6755015523"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleStoreClick('app-store')}
          _hover={{ textDecoration: 'none', opacity: 0.9 }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.1 }}
        >
          <img
            src={`${import.meta.env.BASE_URL}images/app-store-badge.svg`}
            alt="Download on the App Store"
            style={{ height: badgeHeight }}
          />
        </MotionLink>
      )}

      {/* Play Store Badge */}
      {showPlayStore && (
        <MotionLink
          href="https://play.google.com/store/apps/details?id=live.frogbox.connect"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleStoreClick('play-store')}
          _hover={{ textDecoration: 'none', opacity: 0.9 }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.1 }}
        >
          <img
            src={`${import.meta.env.BASE_URL}images/google-play-badge.svg`}
            alt="Get it on Google Play"
            style={{ height: badgeHeight }}
          />
        </MotionLink>
      )}
    </Flex>
  );
}
